<template>
  <v-flex d-block xs12>
    <v-card>
      <v-card-title>
        <h3 style="display: inline-block;">Available services</h3>
      </v-card-title>
      <v-card-text>
        <v-switch
          label="Show services with clients"
          v-model="showServicesWithClients"
          class="pl-3 pt-4 sticky-block"
        />
        <table class="v-table table-striped theme--light">
          <thead>
          <tr>
            <th class="column text-xs-left">Title</th>
            <th class="column text-xs-left">Code</th>
            <th class="column text-xs-left">Group</th>
            <th class="column text-xs-left">Base price</th>
            <th class="column text-xs-left">Initial scope of work</th>
            <th/>
          </tr>
          </thead>
          <tbody>
          <service-item v-for="service in visibleServices"
                        v-bind:key="service.id"
                        v-bind:item="service"
                        @edited="handleServiceEditEvent"
                        @deleted="handleServiceDeletedEvent">
          </service-item>
          </tbody>
        </table>
        <v-flex d-block xs6>
          <service-creation-form :selectedServiceItem="selectedServiceItem"
          :availableServiceGroups="availableServiceGroups"
          :visible="createServiceFormVisible"
          :availableContractors="availableContractors"
          @created="handleCreationFormCreatedEvent"
          @updated="handleServiceUpdatedEvent"
          @close="handleCreationFormCloseEvent"></service-creation-form>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState } from 'vuex'
import ServiceCreationForm from './ServiceCreationForm'
import ServiceItem from './ServiceItem'
import _ from 'lodash'

export default {
  name: 'services',
  components: {
    ServiceCreationForm,
    ServiceItem
  },
  props: {
    items: {
      type: Array
    },
    servicesIdWithClients: {
      type: Array
    },
    availableContractors: {
      type: Array
    },
    clickExternalCreateServices: {
      type: Boolean
    }
  },
  data() {
    return {
      loading: false,
      createServiceFormVisible: false,
      showServicesWithClients: true,
      selectedServiceItem: null
    }
  },
  computed: {
    ...mapState({
      availableServiceGroups: 'availableServiceGroups'
    }),
    visibleServices() {
      let result = this.items
      if (this.showServicesWithClients === true) {
        result = _.filter(this.items, (v) => _.indexOf(this.servicesIdWithClients, v.id) !== -1)
      }

      return _.sortBy(result, 'code')
    }
  },
  watch: {
    clickExternalCreateServices: function() {
      this.selectedServiceItem = null
      this.createServiceFormVisible = !this.createServiceFormVisible
    }
  },
  methods: {
    handleServiceEditEvent(item) {
      this.selectedServiceItem = item
      this.createServiceFormVisible = !this.createServiceFormVisible
    },
    handleClickCreateServiceButton() {
      this.selectedServiceItem = null
      this.createServiceFormVisible = !this.createServiceFormVisible
    },
    handleCreationFormCreatedEvent() {
      this.createServiceFormVisible = false
      this.$emit('serviceCreated')
    },
    handleCreationFormCloseEvent() {
      this.createServiceFormVisible = false
    },
    handleServiceUpdatedEvent(updatedService) {
      this.$emit('serviceUpdated', updatedService)
    },
    handleServiceDeletedEvent(deletedService) {
      this.$emit('serviceDeleted', deletedService)
    }
  }
}
</script>

<style scoped>
  .sticky-block {
    position: sticky;
    top: 50px;
    padding-top: 5px;
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sales/Services.vue